import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LogsService {

  _baseURL: string = environment.baseURL;
  _layout: string = environment.layout;
  _content: string = environment.content;
  _site: string = environment.site
  _page: string = "monitoring_usage";
  _program: string = "monitoring_usage_dashboard.p"; 

  constructor(private _http: HttpClient) { }

  loadIfaceLogs(oparams: any) {

    let params = new HttpParams();
        params = params.append("site", this._site);
        params = params.append("layout", this._layout);
        params = params.append("page", this._page);
        params = params.append("action", "getlog");
        params = params.append("iface", oparams.iface);
        params = params.append("company", oparams.company);
        params = params.append("whse", oparams.warehouse);
        params = params.append("content", "json");

    return this._http.get(`${this._baseURL}${this._program}`, {params: params} );
  }

  getIrmsLog() {

    let params = new HttpParams();
        params = params.append("site", this._site);
        params = params.append("layout", this._layout);
        params = params.append("page", this._page);
        params = params.append("action", "getIrmsLog");       
        params = params.append("content", "json");

    return this._http.get(`${this._baseURL}${this._program}`, {params: params} );
  }
}
